import buildUrl from 'build-url'
import BaseAPIService from '@/services/baseAPIService'

export default class AIAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Request a report
  requestAgentReport(reportData) {
    return this.httpClient.post(`/ai/chat/startReport`, reportData)
  }

  createConversation(agentId, convData) {
    return this.httpClient.post(`/ai/agents/${agentId}/conversations`, convData)
  }

  getConversation(id) {
    return this.httpClient.get(`/ai/conversations/${id}`)
  }
  deleteConversation(id) {
    return this.httpClient.delete(`/ai/conversations/${id}`)
  }
  
  getAgent(id) {
    return this.httpClient.get(`/ai/agents/${id}`)
  }
  updateAgent(id, data) {
    return this.httpClient.put(`/ai/agents/${id}`, data)
  }
  getAgentConversationList(agentId) {
    return this.httpClient.get(`/ai/agents/${agentId}/conversations`)
  }
  getAgentList() {
    return this.httpClient.get(`/ai/agents`)
  }
}